import React, {useState, useEffect, useRef} from "react";

import {Grid, Modal} from "@mui/material";
import * as PropTypes from "prop-types";
import {ButtonSpacer} from "../../../../components/ButtonSpacer";
import {connect} from "react-redux";
import {getLocation} from "../../../location/location.actions";
import { useNavigate} from "react-router-dom";
import {handleCurrentDateCalulcations} from "../../components/functionFormComponentUtils";
import {
    archiveFunction,
    setFunction,
    getFunction,
    saveFunction,
    unsetFunction,
    createFunction,
    listFunctionTemplates,
    getSharedMunicipalities,
    updateSharedFunction,
    createSharedFunction,
    setYouthData,
    getYouthCardInfo, getSharedFunction
} from "../../function.actions";
import {askUpdates, updateContentIdentifierChoices} from "../../../root/root.actions";
import {listLocations} from "../../../location/location.actions";
import { ButtonSecondary } from "../../../../components/newComponents/ButtonSecondary";
import {
    listMunicipalityUsersSilent,
    listOrganizations,
    getOrganizationTree, listMunicipalities, getMunicipality
} from "../../../municipality/municipality.actions";
import {useTranslation, withTranslation, Trans} from "react-i18next";
import {formatISODateStr, generateKey} from "../../../../utils";
import {selectButtonType} from "../../../../components/utils";
import {
    hasPermission,
    PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY,
    PERMISSION_ARCHIVE_ANY_FUNCTION,
    PERMISSION_ARCHIVE_OWN_FUNCTION
} from "../../../../permissions";
import {FunctionTemplateComp} from "./createFunction/functionFunctionTemplate";
import {FunctionMunicipalityComp} from "./createFunction/functionMunicipality";
import {FunctionOrganizationAndLocationComp} from "./createFunction/functionOrganizationAndLocationComponent";
import {FunctionInformationComp} from "./createFunction/functionFunctionInformation";
import {FunctionParticipantsAndFeedbackComp} from "./createFunction/functionParticipantsAndFeedback";
import {FunctionFeedbackComp} from "./createFunction/functionFeedbackComponent";
import { ButtonPrimary } from "../../../../components/newComponents/ButtonPrimary";
import { Prompt } from "../../../../components/newComponents/Prompt";

const FunctionFormComponent = (props) => {
    const {
        functionId,
        action,
        shared,
        openSharedWarningModal,
        fieldErrors = {},
        selectedFunction,
        func,
        authenticatedUser,
        locations
    } = props;
    
    const {t} = useTranslation('translation');
    //use location.state to get correct copymode data. If not used, moment object format fails and everything goes boom
    const [deleteTemplateModalOpen, setDeleteTemplateModalOpen] = useState(false);
    const [deletionModal, setDeletionModal] = useState(false)

    const navigate = useNavigate();
    //const allowNavigation = useRef(false);
    
    const [initialFunctionString, setInitialFunctionString] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    
    const municipalitySelect = hasPermission(PERMISSION_CREATE_FUNCTION_ANY_MUNICIPALITY, authenticatedUser) && action !== "share";

    const sharedMunicipalityItems = selectedFunction.sharedMunicipalities ? selectedFunction.sharedMunicipalities : [];

    const currentFunctionString = selectedFunction ? JSON.stringify(selectedFunction) : null;
        
    const isDirty = 
        initialFunctionString !== null && 
        currentFunctionString !== initialFunctionString;

    useEffect(() => {
        if (initialFunctionString !== null) return;

        if (selectedFunction) {
            setInitialFunctionString(JSON.stringify(selectedFunction));
        }
    }, [selectedFunction, initialFunctionString]);
    
    //function data load logic
    useEffect(() => {
        const initialize = async () =>{
            try {
                //load function data
                let functionData;
                if (action === "share") {
                    functionData = await new Promise((resolve) =>
                        props.getFunction(props.shareCode, true, resolve)
                    );
                } else if (functionId) {
                    const data = await new Promise((resolve) => {
                        if (shared) {
                            return props.getSharedFunction(functionId, resolve);
                        }
                        else {
                            return props.getFunction(functionId, false, resolve)
                        }
                    });
                    let returnData;
                    if(action === 'copy') {
                        returnData = {
                            eventType: data.eventType,
                            locationId: data.locationId,
                            locationName: data.locationName,
                            locationPostCode: data.locationPostCode,
                            locationTypeId: data.locationTypeId,
                            organizationId: data.organizationId,
                            serviceId: data.serviceId,
                            name: data.name,
                            municipalityId: data.municipalityId,
                            methods: structuredClone(data.methods),
                            organizers: structuredClone(data.organizers),
                            contentIdentifiers: structuredClone(data.contentIdentifiers),
                            startDatetime: data.startDatetime,
                            endDatetime: data.endDatetime,
                            eventHours: data.eventHours
                        };
                        if (data.startDatetime) {
                            returnData.startTime = data.startDatetime.split("T")[1];
                        }
                        if (data.endDatetime) {
                            returnData.endTime = data.endDatetime.split("T")[1];
                        }
                        handleCurrentDateCalulcations(returnData);
                    } else {
                        returnData = data;
                    }
                    functionData = returnData;
                }
                else {
                    functionData = {
                        municipalityId: props.selectedMunicipality.id,
                        startDate: formatISODateStr(Date.now()),
                        endDate: formatISODateStr(Date.now()),
                        startDatetime: null,
                        endDatetime: null
                    }
                }

                //load municipality data
                props.askUpdates();
                props.listMunicipalities();

                const municipalityId = functionData.municipalityId || (props.selectedMunicipality.id && municipalitySelect
                        ? props.selectedMunicipality.id
                        : props.authenticatedUser.mainMunicipalityId);

                if (municipalityId) {
                    let specialId = action === "share" ? props.authenticatedUser.mainMunicipalityId : (functionData.shareEventMunicipalityId ? functionData.shareEventMunicipalityId : municipalityId)

                    props.getMunicipality(specialId);

                    //load rest of data for dropdowns etc
                    props.listFunctionTemplates(municipalityId);
                    props.listLocations(municipalityId);
                    props.listOrganizations(specialId);
                    props.getOrganizationTree(specialId, 10);
                    props.updateContentIdentifierChoices(municipalityId);
                }
                if (action !== "share" && functionData.shared && functionData.shareCode && !functionData.shareEventMunicipalityId) {
                    props.getSharedMunicipalities(functionData.shareCode);
                }
                props.setFunction(functionData);

            } catch (err) {
                console.error("error:", err);
            }
        };
        initialize();
    }, [functionId]);

    const sectionHasError = (errorFields) => {
        let returnValue = false;
        errorFields.forEach(errorField => {
            if (errorField in fieldErrors) {
                returnValue = true;
            }
        })
        return returnValue;
    }

    const handleSubmitShared = () => {
        const functionData = {...selectedFunction};
        _createSharedFunction(functionData);
    }

    const _createSharedFunction = (data) => {
            if (!data['municipalityId']) {
                data['municipalityId'] = props.selectedMunicipality.id;
            }
            props.createSharedFunction(data, () => {
                navigate('/function', {showSuccess: true});
            })
        }

    const handleUpdateShared = () => {
        const data = {...selectedFunction};
        if (!data['municipalityId']) {
            data['municipalityId'] = props.selectedMunicipality.id;
        }
        setIsSaving(true);
        //allowNavigation.current = true

        props.updateSharedFunction(data, () => {
            navigate('/function');
            //return setFunction(data);
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSaving(true);
        const functionData = { ...selectedFunction };
        //allowNavigation.current = true

        if (!functionData['municipalityId']) {
            functionData['municipalityId'] = props.selectedMunicipality.id;
        }

        if (action === 'copy') {
            props.createFunction(functionData, false, () => {
                navigate('/function', {showSuccess: true});
            });
        } else if(functionData.id) {
            props.saveFunction(functionData.id, functionData,
                () => { navigate('/function'); }
            );
        } else {
            props.createFunction(functionData, false, () => {
                navigate('/function', {showSuccess: true});
            });
        }
    };

    //TODO translations
    const closeWithoutSaving = () => {
        navigate('/function')
    }

    const archiveConfirmation = (event) => {
        event.preventDefault()
        setIsSaving(true);
        //allowNavigation.current = true
        props.archiveFunction(selectedFunction.id, (selectedFunction.municipalityId !== props.selectedMunicipality.id) ? selectedFunction.shareEventId : null, () => { //fixme
            props.listFunctionTemplates(props.selectedMunicipality.id);
            navigate('/function')
            return unsetFunction();
        })
    }

    const _deleteArchiveFunction = () => {
        if (!selectedFunction) return;
        setDeleteTemplateModalOpen(true)
    }

    const deleteSharedFunction = () => {
        if (!selectedFunction) return;
        setDeletionModal(true)
        setDeleteTemplateModalOpen(true)
    }

    const goBack = () => {
        //to retain search values in functionIndex page
        navigate(-1)
    }

    let actionButtons = [
        {
            type: "primary",
            label: t('common.close_without_saving'),
            className: "function-cancel",
            onClick: closeWithoutSaving
        }
    ];

    if (selectedFunction && selectedFunction.id) {
        let canArchive = false;
        if (hasPermission(PERMISSION_ARCHIVE_ANY_FUNCTION, authenticatedUser)) {
            canArchive = true;
        } else if (hasPermission(PERMISSION_ARCHIVE_OWN_FUNCTION, authenticatedUser)) {
            if (selectedFunction.creatorId === authenticatedUser.id) {
                canArchive = true;
            }
            else {
                selectedFunction.organizers.forEach((organizer) => {
                    if (organizer.id === authenticatedUser.id) {
                        canArchive = true;
                    }
                })
            }
        }
        if (canArchive) {
            if (selectedFunction.shareEventId) {
                actionButtons = [
                    {
                        type: "attention",
                        label: t('common.remove'),
                        className: "archive-button",
                        onClick: deleteSharedFunction
                    }
                ];
            }
            else {
                actionButtons = [
                    {
                        type: "delete",
                        label: t('common.archive'),
                        className: "archive-button",
                        onClick: _deleteArchiveFunction
                    }
                ];
            }
        } else {
            actionButtons = [];
        }
        actionButtons.push(
            {
                type: "primary",
                label: t('common.close_without_saving'),
                className: "",
                onClick: goBack
            }
        );
    }

    if (action === 'view') {
        actionButtons = [
            {
                type: "primary",
                label: t('feedback.goBack'),
                className: "",
                onClick: goBack
            },
        ];
    }
    
    //NOTE: this button is only displayed if the function is shared. Not to be displayed if the function is being created
    if (action === 'share') {
        actionButtons.push({
            type: "primary",
            label: t('function.create_shared'),
            className: "",
            onClick: handleSubmitShared
        });
    } else if (action === "edit" || action === "copy" || action === "create") {
        actionButtons.push({
            type: "primary",
            label: t('common.save'),
            className: "",
            onClick: selectedFunction.shareEventId ? handleUpdateShared : handleSubmit
        });
    }

    const closeDeleteModal = (event) => {
        event.preventDefault();
        setDeleteTemplateModalOpen(false);
    };

    const handleClick = (event, callback) => {
        event.preventDefault()
        const data = {...selectedFunction}
        callback(event, data);
    };

    let componentActionButtons = [];
    if (actionButtons) {
        actionButtons.forEach(function (button) {
            const key = generateKey('funcEditButton');
            selectButtonType(button, componentActionButtons, key, handleClick);
        });
    }

    const editorActivated = action !== "view"

    const handleChange = (e, changedData) => {
        let data = {
            ...selectedFunction,
            [e.target.name]: e.target.value
        }
        if (changedData) {
            data = {
                ...selectedFunction,
                ...changedData
            }
        }
        props.setFunction(data);
    }
    
    const handleMultiselectChange = (event, value, choice) => {
        event.preventDefault();

        if (value) {
            selectedFunction[choice.key] = false;

            if(choice.key === "shared" && sharedMunicipalityItems.length > 0) {
                openSharedWarningModal();
            }
        }
        else {
            selectedFunction[choice.key] = true;
        }
        
        const data = {
            target: {
                value: selectedFunction[choice.key],
                name: choice.key
            },
        };
        handleChange(data);
    }

    let lowerAction = action !== "view" && selectedFunction.shareEventId ? "share" : action;

    return (
        <form noValidate autoComplete="off" className={"function-container"}>
            <Prompt
                when={isDirty && !isSaving && action !== "view" && action !== "share"}
                message={t("function.continue_without_saving")}
            />
            <Grid container>
                <Grid item xs={12} sx={{width: "100%"}}>
                    <FunctionMunicipalityComp
                        key={selectedFunction?.id}
                        editorActivated={editorActivated}
                        handleChange={handleChange}
                        action={lowerAction}
                        municipalitySelect={municipalitySelect}
                        sectionHasError={sectionHasError}
                        fieldErrors={func.functionFieldErrors}
                    />
                </Grid>
                <Grid item xs={12} sx={{borderTop: '1px solid rgba(0,0,0,0.3)', width: "100%"}}>
                    {action === "create" && <FunctionTemplateComp
                        key={selectedFunction?.id} 
                        editorActivated={editorActivated}
                        handleChange={handleChange}
                        action={lowerAction}
                        sectionHasError={sectionHasError}
                        fieldErrors={func.functionFieldErrors}
                        locations={locations}
                    />}
                </Grid>
                <Grid item xs={12} sx={{borderTop: '1px solid rgba(0,0,0,0.3)', width: "100%"}}>
                    <FunctionOrganizationAndLocationComp
                        key={selectedFunction?.id}
                        editorActivated={editorActivated}
                        handleChange={handleChange}
                        action={lowerAction}
                        sectionHasError={sectionHasError}
                        fieldErrors={func.functionFieldErrors}
                    />
                </Grid>
                <Grid item xs={12} sx={{borderTop: '1px solid rgba(0,0,0,0.3)', width: "100%"}}>
                    <FunctionInformationComp
                        key={selectedFunction?.id}
                        editorActivated={editorActivated}
                        handleChange={handleChange}
                        action={lowerAction}
                        municipalitySelect={municipalitySelect}
                        sectionHasError={sectionHasError}
                        fieldErrors={func.functionFieldErrors}
                        forceOrganizer={true}
                    />
                </Grid>
                <Grid item xs={12} sx={{borderTop: '1px solid rgba(0,0,0,0.3)', width: "100%"}}>
                    <FunctionParticipantsAndFeedbackComp
                        key={selectedFunction?.id}
                        editorActivated={editorActivated}
                        functionId={functionId}
                        handleChange={handleChange}
                        handleMultiselectChange={handleMultiselectChange}
                        action={lowerAction}
                        sectionHasError={sectionHasError}
                        fieldErrors={func.functionFieldErrors}
                    />
                </Grid>
                <Grid item xs={12} sx={{width: '100%', borderTop: '1px solid rgba(0,0,0,0.3)'}}>
                    {/* {action !== "copy" &&  */}
                    <FunctionFeedbackComp
                        key={selectedFunction?.id}
                        editorActivated={editorActivated}
                        handleChange={handleChange}
                        handleMultiselectChange={handleMultiselectChange}
                        action={lowerAction}
                        functionId={functionId}
                    />
                </Grid>
                <Modal open={deleteTemplateModalOpen} onClose={closeDeleteModal}>
                        <div className={'modal archiveModal'}>
                            <div className={'modalDescription'}>
                                {deletionModal ? <Trans i18nKey="function.delete_desc"/> : (selectedFunction.shared ? <Trans i18nKey="function.archive_desc_shared"/> : <Trans i18nKey="function.archive_desc"/>)}
                            </div>
                            <div className={'modalQuestion'}>
                                {deletionModal ? t('function.deletion_question') : t('function.archive_question')}
                            </div>
                            <div className={'modalButtons'}>
                                <ButtonSecondary
                                    key={'cancel'}
                                    onClick={closeDeleteModal}>
                                    {t('common.cancel')}
                                </ButtonSecondary>
                                <ButtonPrimary
                                    key={'delete-archive'}
                                    onClick={archiveConfirmation}>
                                    {deletionModal ? t('common.remove') : t('common.archive')}
                                </ButtonPrimary>
                            </div>
    
                        </div>
                    </Modal>
            </Grid>
                <Grid className='MuiGrid-item' size={12} sx={{display: 'flex', flexDirection: 'row-reverse'}}>
                    <ButtonSpacer>
                        {componentActionButtons}
                    </ButtonSpacer>
                </Grid>
        </form>
    );
}

FunctionFormComponent.propTypes = {
    label: PropTypes.string,
    editorActivated: PropTypes.bool,
    shared: PropTypes.bool,
    selectedFunction: PropTypes.object,
    selectedLocation: PropTypes.object,
    fieldErrors: PropTypes.object,
    actionButtons: PropTypes.array,
    functionTemplateButtons: PropTypes.array,
    allPartitionsOpen: PropTypes.bool,
    updateData: PropTypes.bool,
    youthData: PropTypes.object
};

const mapStateToProps = (state) => {
    // return state;
    return {
        municipalities: state.municipality.municipalities,
        selectedFunction: state.func.selectedFunction,
        selectedMunicipality: state.municipality.selectedMunicipality,
        selectedMunicipalityUsers: state.municipality.selectedMunicipalityUsers,
        selectedTemplateHandlers: state.municipality.selectedTemplateHandlers,
        organizations: state.municipality.organizations,
        functionFieldErrors: state.func.functionFieldErrors,
        organizationTree: state.municipality.organizationTree,
        locations: state.location.locations,
        locationTypes: state.root.locationTypes,
        services: state.root.services,
        contentIdentifiers: state.root.contentIdentifiers,
        methods: state.root.methods,
        templates: state.func.templates,
        func: state.func,
        authenticatedUser: state.auth.authenticatedUser
    }
}
const mapDispatchToProps = dispatch => {
    return {
        askUpdates: () => dispatch(askUpdates()),
        listMunicipalities: () => dispatch(listMunicipalities()),
        archiveFunction: (id, shareEventId = null, onSuccess) => dispatch(archiveFunction(id, shareEventId, onSuccess)),
        getLocation: (id, onSuccess) => dispatch(getLocation(id, onSuccess)),
        setFunction: (data) => dispatch(setFunction(data)),
        getFunction: (id, isShared, onSuccess) => dispatch(getFunction(id, isShared, onSuccess)),
        getSharedFunction: (id, onSuccess) => dispatch(getSharedFunction(id, onSuccess)),
        unsetFunction: () => dispatch(unsetFunction()),
        createSharedFunction: (data, onSuccess) => dispatch(createSharedFunction(data, onSuccess)),
        saveFunction: (id, data, onSuccess) => dispatch(saveFunction(id, data, onSuccess)),
        createFunction: (data, createTemplate, onSuccess, onlyTemplate) => dispatch(createFunction(data, createTemplate, onSuccess, onlyTemplate)),
        listFunctionTemplates: (municipalityId) => dispatch(listFunctionTemplates(municipalityId)),
        listLocations: (municipalityId) => dispatch(listLocations(municipalityId)),
        listMunicipalityUsersSilent: (municipalityId) => dispatch(listMunicipalityUsersSilent(municipalityId)),
        listOrganizations: (municipalityId) => dispatch(listOrganizations(municipalityId)),
        getOrganizationTree: (municipalityId, level) => dispatch(getOrganizationTree(municipalityId, level)),
        updateContentIdentifierChoices: (municipalityId) => dispatch(updateContentIdentifierChoices(municipalityId)),
        getYouthCardInfo: (eventId) => dispatch(getYouthCardInfo(eventId)),
        getSharedMunicipalities: (shareId) => dispatch(getSharedMunicipalities(shareId)),
        setYouthData: (data) => dispatch(setYouthData(data)),
        getMunicipality: (id, onSuccess) => dispatch(getMunicipality(id, onSuccess)),
        updateSharedFunction: (data, onSuccess) => dispatch(updateSharedFunction(data, onSuccess)),
    };
}

export const CreateFunctionForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translation')(FunctionFormComponent));